(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  function countdown(countdowns) {
      let days, hours, minutes, seconds, int=[], i=0;

      [].forEach.call(countdowns, function(countdown) {
          int[i] = setInterval(function(){
              if		(countdown && countdown.parentNode && countdown.dataset.deadline) calculate(countdown, countdown.dataset.deadline);
              else	clearInterval(int[i]);
          }, 1000);
          i += 1;
      });

      function calculate(countdown, endDate) {
          if (isNaN(endDate)) {
              return;
          }

          let counter, startDate = new Date();
          startDate = startDate.getTime();

          let timeRemaining = parseInt((endDate - startDate) / 1000);

          if (timeRemaining >= 0) {
              days			= parseInt(timeRemaining / 86400);
              timeRemaining	= (timeRemaining % 86400);

              hours			= parseInt(timeRemaining / 3600);
              timeRemaining	= (timeRemaining % 3600);

              minutes			= parseInt(timeRemaining / 60);
              timeRemaining	= (timeRemaining % 60);

              seconds			= parseInt(timeRemaining);

              if (countdown.classList.contains('words')) {
                  if (days) {
                      counter = parseInt(days, 10) + ' days - ';
                  } else {
                      counter = '';
                  }
/*
                  counter	+=	('0' + hours	).slice(-2)	+ ' hours ' +
                              ('0' + minutes	).slice(-2)	+ ' minutes ' +
                              ('0' + seconds	).slice(-2)	+ ' seconds ';
*/

                  counter	+=	('0' + hours	).slice(-2)	+ ' hours ';
              } else if (countdown.classList.contains('days')) {
                  counter = parseInt(days, 10) + ' days ';
              } else {
                  if (days) {
                      counter = parseInt(days, 10) + ':';
                  } else {
                      counter = '';
                  }

                  counter	+=	('0' + hours	).slice(-2)	+ ':' +
                              ('0' + minutes	).slice(-2)	+ ':' +
                              ('0' + seconds	).slice(-2);
              }

              countdown.innerText = counter;
          } else if (countdown && countdown.parentNode) {
              countdown.innerText = '';
              countdown.parentNode.removeChild(countdown);
          }
      }
  }

  (function () {
      var countdowns = document.querySelectorAll('.countdown');
      if (countdowns) countdown(countdowns);
  }());

  } catch(e) { console.error(e); }
})();
})();
